import React from 'react';
import { motion } from 'framer-motion';
import { Zap, Palette, Link2 } from 'lucide-react';
const benefits = [{
  icon: Zap,
  title: 'Tiempo Récord',
  description: 'Entregamos en 5 días lo que otros tardarían meses. Nuestra tecnología AI acelera cada paso del proceso.',
  color: 'text-yellow-400',
  bg: 'bg-yellow-400/10',
  border: 'border-yellow-400/20',
  glow: 'group-hover:shadow-yellow-400/20'
}, {
  icon: Palette,
  title: 'Creatividad Sin Límites',
  description: 'Diseño único, lleno de colores y conceptos fuera de la caja. Cada página es una obra de arte digital.',
  color: 'text-pink-500',
  bg: 'bg-pink-500/10',
  border: 'border-pink-500/20',
  glow: 'group-hover:shadow-pink-500/20'
}, {
  icon: Link2,
  title: 'Integración Total',
  description: 'Dominio propio, conexión a Meta Ads, WhatsApp, CRM y más. Todo listo para convertir visitantes en clientes.',
  color: 'text-cyan-400',
  bg: 'bg-cyan-400/10',
  border: 'border-cyan-400/20',
  glow: 'group-hover:shadow-cyan-400/20'
}];
export function BenefitsSection() {
  return <section id="beneficios" className="py-24 bg-[#050510] relative overflow-hidden" data-id="element-14">
      <div className="absolute inset-0 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-20" data-id="element-15"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-16">
        <div className="text-center mb-16" data-id="element-17">
          <h2 className="text-3xl md:text-5xl font-bold font-orbitron mb-4" data-id="element-18">
            Poder <span className="text-gradient-cosmic" data-id="element-19">Ilimitado</span>
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto" data-id="element-20">
            Combinamos tecnología de punta con diseño de clase mundial para
            resultados explosivos.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-21">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className={`group p-8 rounded-2xl bg-[#0a0a1a] border ${benefit.border} hover:border-opacity-50 transition-all duration-300 hover:-translate-y-2 ${benefit.glow} shadow-lg`} data-id="element-22">
              <div className={`w-14 h-14 rounded-xl ${benefit.bg} flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300`} data-id="element-23">
                <benefit.icon className={`w-7 h-7 ${benefit.color}`} data-id="element-24" />
              </div>
              <h3 className="text-xl font-bold font-orbitron text-white mb-4 group-hover:text-gradient-cosmic transition-colors" data-id="element-25">
                {benefit.title}
              </h3>
              <p className="text-gray-400 leading-relaxed" data-id="element-26">
                {benefit.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}